/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// @components
import ServiceCard from "./ServiceCard";
import { NoServiceMessage } from "./NoServiceMessageCard";

// @types
import { ServiceRequest } from "../../../types/request.types";
import routesConfig from "../../../config/routes.config";
import ButtonScroll from "../../../components/molecules/ButtonScroll";

const CanceledService: React.FC<{ services: ServiceRequest[] | null }> = ({ services }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleServiceClick = (service: ServiceRequest) => {
        navigate(`${routesConfig.serviceDetail}${service.serviceRequestId}`, { state: { service } });
    };

    return (
        <section>
            <h2 className="text-[15px] font-semibold mb-4">{t("myServices.cancelService")}</h2>
            <div className="rounded-lg p-5 bg-cBackgroundSecondary">
                {services?.length === 0 ? (
                    <NoServiceMessage
                        title={t("myServices.noServiceMessage.titleCanceled")}
                        messageOne={t("myServices.noServiceMessage.messageOneCanceled")}
                        buttonText={t("myServices.noServiceMessage.requestButton")}
                        onClick={() => navigate("/categories")}
                    />
                ) : (
                    <>
                        <ButtonScroll>
                            {services?.map((service: ServiceRequest) => (
                                <div className="flex-none w-72" key={service.serviceRequestId}>
                                    <ServiceCard
                                        key={service.professionalId}
                                        service={service}
                                        onClick={() => handleServiceClick(service)}
                                    />
                                </div>
                            ))}
                        </ButtonScroll>
                    </>
                )}
            </div>
        </section>
    )
}

export default CanceledService